import { render, staticRenderFns } from "./PdpYotpoRating.vue?vue&type=template&id=6acb40b2&"
import script from "./PdpYotpoRating.vue?vue&type=script&lang=js&"
export * from "./PdpYotpoRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports